export const paginationMessages = {
  showAll: "Показать все",
  rowsPerPage: "Строк на странице",
  info: (parameters: {from: number; to: number; count: number}) =>
    `${parameters.from} из ${parameters.to}. Всего: ${parameters.count}`
};
